var React = require('react');

function ArrowRightRed (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"id":"Rectangle_21","data-name":"Rectangle 21","width":"52","height":"52","fill":"#e62a2c","key":0}),React.createElement("path",{"id":"Path_16","data-name":"Path 16","d":"M-1017.088-565.4l17.758-17.758-17.758-17.758-3.432,3.432,14.326,14.326-14.326,14.326Z","transform":"translate(1036.896 609.315)","fill":"#fff","key":1})]);
}

ArrowRightRed.defaultProps = {"id":"Group_5","data-name":"Group 5","width":"52","height":"52","viewBox":"0 0 52 52"};

module.exports = ArrowRightRed;

ArrowRightRed.default = ArrowRightRed;
